import React, { useEffect, useState } from 'react';
import { IActivedTab } from '../index';
import { Comentarios } from './Comentario';
import { Bordas } from './Borda';
import { Extra } from './Extra';
import { Sabores } from './Sabores';
import { InputHook } from '../../../../../reactHookForm/InputHook';
import { CheckboxHookLeft } from '../../../../../reactHookForm/inputCheckboxLeft';
import { RadioHookLeft } from '../../../../../reactHookForm/RadioHookLeft';
import { FooterIntern } from '../FooterIntern';
import { NavbarIntern } from '../NavbarIntern';
import CustomLoader from '../../../../../data/customLoader';
import { ValidationErrorBanner } from './ValidationErrorBanner';
import './errorStyles.css';

interface IProps {
  activedtab: IActivedTab;
  register: any;
  inputError: any;
  stateForm: any;
  control: any;
  setValue: any;
  watch: any;
  pizzaEdite: any;
  invalidFields?: string[];
}

export function Body({
  activedtab,
  register,
  inputError,
  stateForm,
  control,
  setValue,
  watch,
  pizzaEdite,
  invalidFields = []
}: IProps) {
  
  const [loading, setLoading] = useState(true);
  
  // Função helper para verificar se um campo é inválido
  const isFieldInvalid = (fieldName: string) => {
    return invalidFields.includes(fieldName);
  };
  
  useEffect(() => {
    if (!pizzaEdite) {
      setValue("NumberItems", "2");
      setValue("MinimumPrice", "0.00");
      setValue("MaximumItems", "1");
      setValue("NumberFreetems", "1");
      setValue("NumberFreelngredients", "2");
      setValue("TabletTerminals", "1");
      setValue("SellingRules", "1");
    } else {
      setValue("MinimumPrice", pizzaEdite?.MinimumPrice);
      setValue("Free", pizzaEdite.Free === 1);
      setValue("IsTablet", pizzaEdite.IsTablet === 1);
      setValue("CloseAfterFlavor", pizzaEdite.CloseAfterFlavor === 1);
      setValue("NumberItems", pizzaEdite?.NumberItems);
      setValue("MaximumItems", pizzaEdite?.MaximumItems);
      setValue("SellingRules", pizzaEdite?.SellingRules?.toString() || "1");
      setValue("PayBorderbigint", pizzaEdite.PayBorderbigint === 1);
      setValue("NumberFreetems", pizzaEdite?.NumberFreetems);
      setValue("TabletTerminals", pizzaEdite?.TabletTerminals?.toString() || "1");
      setValue("NumberFreelngredients", pizzaEdite?.NumberFreelngredients);
      setValue("GroupIdForObservation", pizzaEdite?.GroupIdForObservation);
      setValue("PvpForObservations", pizzaEdite?.PvpForObservations);
      setValue("ChangeDescription", pizzaEdite.ChangeDescription === 1);
    }
  }, [pizzaEdite, setValue]);
  
  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 3500);

    return () => clearTimeout(timeout);
  }, []);
  
  return (
    <section>
      <div className="sidebar">
        {/* Banner de erros - aparece quando há campos inválidos */}
        {invalidFields.length > 0 && (
          <ValidationErrorBanner 
            errors={[]} 
            invalidFields={invalidFields}
          />
        )}
        
        <div className="divisor">
          <h2>Configurações</h2>
          <div className={isFieldInvalid('NumberItems') ? 'input-error' : ''}>
            <InputHook
              register={register}
              errors={inputError}
              defaultValue={pizzaEdite?.NumberItems ?? 2}
              label="Número de sabores"
              name="NumberItems"
              placeholder="0,00"
              type="number"
              min="0"
              disabled={stateForm.state === "loading"}
            />
          </div>
          <div className={isFieldInvalid('MinimumPrice') ? 'input-error' : ''}>
            <InputHook
              register={register}
              errors={inputError}
              setValue={setValue}
              watch={watch}
              label="Preço mínimo de venda"
              name="MinimumPrice"
              defaultValue={pizzaEdite?.MinimumPrice ?? "0,00"}
              placeholder="0,00"
              type="text"
              min="0"
              disabled={stateForm.state === "loading"}
              isCurrency={true}
            />
          </div>
          <div className={isFieldInvalid('MaximumItems') ? 'input-error' : ''}>
            <InputHook
              register={register}
              errors={inputError}
              defaultValue={pizzaEdite?.MaximumItems ?? 1}
              label="Maxímo ingredientes por sabor"
              name="MaximumItems"
              placeholder="0,00"
              type="number"
              min="0"
              disabled={stateForm.state === "loading"}
            />
          </div>

          <div className="marl">
            <div className="tablet">
              <CheckboxHookLeft
                register={register}
                errors={inputError}
                label="Visual de tablet"
                name="IsTablet"
                disabled={stateForm.state === 'loading'}
              />
              <div className={isFieldInvalid('TabletTerminals') ? 'input-error' : ''}>
                <InputHook
                  register={register}
                  errors={inputError}
                  defaultValue={pizzaEdite?.TabletTerminals ?? "1"}
                  name="TabletTerminals"
                  placeholder="0"
                  type="text"
                  min="0"
                  disabled={stateForm.state === 'loading'}
                />
              </div>
            </div>
            <CheckboxHookLeft
              register={register}
              errors={inputError}
              label="Concluir pizza após selecionar sabores"
              name="CloseAfterFlavor"
              disabled={stateForm.state === 'loading'}
            />
            <CheckboxHookLeft
              register={register}
              errors={inputError}
              defaultValue={true}
              label="Alterar a descrição dependendo do número de sabor"
              name="ChangeDescription"
              disabled={stateForm.state === 'loading'}
            />
          </div>
        </div>

        <div className="divisor">
          <h2>Regras de Venda</h2>
          <div className={`marl ${isFieldInvalid('SellingRules') ? 'section-error' : ''}`}>
            <RadioHookLeft
              register={register}
              errors={inputError}
              value="1"
              defaultValue="1"
              label="Maior valor dos ingredientes"
              name="SellingRules"
              disabled={stateForm.state === 'loading'}
            />
            <RadioHookLeft
              register={register}
              errors={inputError}
              value="2"
              label="Valor médio dos ingredientes"
              name="SellingRules"
              disabled={stateForm.state === 'loading'}
            />
            <RadioHookLeft
              register={register}
              errors={inputError}
              value="3"
              label="Somatório do valor dos ingredientes"
              name="SellingRules"
              disabled={stateForm.state === 'loading'}
            />
          </div>
        </div>

        <div className="divisor">
          <h2>Extras</h2>
          <div className="marl">
            <CheckboxHookLeft
              register={register}
              errors={inputError}
              label="Paga valor da borda"
              defaultValue={true}
              name="PayBorderbigint"
              disabled={stateForm.state === 'loading'}
            />
          </div>
          <div className={isFieldInvalid('NumberFreetems') ? 'input-error' : ''}>
            <InputHook
              register={register}
              errors={inputError}
              label="Número de extras grátis"
              name="NumberFreetems"
              placeholder="0"
              type="number"
              defaultValue={pizzaEdite?.NumberFreetems ?? '1'}
              min="0"
              disabled={stateForm.state === 'loading'}
            />
          </div>
          <div className={isFieldInvalid('NumberFreelngredients') ? 'input-error' : ''}>
            <InputHook
              register={register}
              errors={inputError}
              label="Número de ingredientes grátis"
              name="NumberFreelngredients"
              placeholder="0"
              type="number"
              defaultValue={pizzaEdite?.NumberFreelngredients ?? '2'}
              min="0"
              disabled={stateForm.state === 'loading'}
            />
          </div>
        </div>

        <div className="divisor">
          <h2>Promoções</h2>
          <div className="marl">
            <CheckboxHookLeft
              register={register}
              errors={inputError}
              label="Pizza preço Zero"
              name="Free"
              disabled={stateForm.state === 'loading'}
            />
          </div>
        </div>
      </div>

      <div className="body">
        <NavbarIntern activedtab={activedtab} />
        <div className='contant'>
          {loading ? (
            <CustomLoader />
          ) : (
            <>
              {activedtab.sabores && <Sabores />}
              {activedtab.borda && <Bordas />}
              {activedtab.extra && <Extra />}
              {activedtab.comentario && <Comentarios />}
            </>
          )}
        </div>
        <FooterIntern activedtab={activedtab} />
      </div>
    </section>
  );
}